import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router';
import { Layout } from '../components/Layout.js';

export function NotFoundPage() {
  const { lang } = useParams();
  const { t } = useTranslation('errors');
  return (
    <Layout>
      <div className="max-w-md mx-auto px-4 py-24 text-center">
        <h1 className="text-5xl font-bold mb-4">404</h1>
        <p className="text-neutral-400 mb-8">{t('not_found')}</p>
        <Link to={`/${lang}`} className="btn-secondary">
          ← Boletra
        </Link>
      </div>
    </Layout>
  );
}
